import { useAuth } from '../App';

export default function Watermark() {
  const { user } = useAuth();
  if (!user) return null;

  const text = `${user.name} · ${user.email}`;

  // Create watermark using canvas
  const canvas = document.createElement('canvas');
  canvas.width = 300;
  canvas.height = 150;
  const ctx = canvas.getContext('2d');
  ctx.font = '12px sans-serif';
  ctx.fillStyle = 'rgba(128,128,128,0.07)';
  ctx.translate(150, 75);
  ctx.rotate(-35 * Math.PI / 180);
  ctx.textAlign = 'center';
  ctx.fillText(text, 0, 0);
  const dataUrl = canvas.toDataURL();

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      pointerEvents: 'none',
      zIndex: 9999,
      backgroundImage: `url(${dataUrl})`,
      backgroundRepeat: 'repeat',
    }} />
  );
}